import { useFaxSent } from '@/hooks'
import { Badge, Loader, NavLink } from '@mantine/core'
import { IconCheck, IconClock, IconExclamationMark, IconSend2 } from '@tabler/icons-react'
import { NavLink as Link } from 'react-router-dom'
import InfiniteScroll from 'react-infinite-scroll-component'
import { formatDateTime } from '@medplum/core'

export function FaxSent() {
  const { data, hasNextPage, fetchNextPage } = useFaxSent()

  const items = data.pages.flatMap((page) => page.items)

  if (!items.length) {
    return <FaxSentEmpty />
  }

  return (
    <InfiniteScroll
      dataLength={items.length}
      next={() => fetchNextPage()}
      hasMore={hasNextPage ?? false}
      loader={<Loader size="sm" className="mx-auto my-2" />}
      scrollableTarget="fax-sent-scroll"
    >
      <ul role="list" className="divide-y divide-gray-200">
        {items.map((item) => (
          <li key={item.messageId}>
            <NavLink
              component={Link}
              to={`/fax/sent/${item.messageId}`}
              label={item.recipient.name ?? item.recipient.phoneNumber}
              description={formatDateTime(item.sentAt)}
              leftSection={<FaxSentItemStatus status={item.messageStatus} />}
            />
          </li>
        ))}
      </ul>
    </InfiniteScroll>
  )
}

function FaxSentEmpty() {
  return (
    <div className="flex flex-auto flex-col items-center justify-center">
      <div className="flex flex-col items-center justify-center gap-3 px-6 py-16 text-center">
        <div className="flex size-16 items-center justify-center rounded-full bg-gray-100">
          <IconSend2 className="size-8 text-gray-400" />
        </div>
        <div>
          <p className="text-sm font-medium text-gray-900">Empty</p>
          <p className="mt-1 text-xs text-gray-500">Sent faxes will appear here.</p>
        </div>
      </div>
    </div>
  )
}

function FaxSentItemStatus({ status }: { status: string }) {
  switch (status) {
    case 'Sent':
    case 'Delivered': {
      return (
        <Badge size="xs" circle color="green">
          <IconCheck size={10} />
        </Badge>
      )
    }
    case 'Queued': {
      return (
        <Badge size="xs" circle color="yellow">
          <IconClock size={10} />
        </Badge>
      )
    }
    case 'SendingFailed': {
      return (
        <Badge size="xs" circle color="red">
          <IconExclamationMark size={10} />
        </Badge>
      )
    }
    default: {
      return (
        <Badge size="xs" circle color="gray">
          <IconClock size={10} />
        </Badge>
      )
    }
  }
}
